import React, { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function ChangePasswordDialog({ open, onClose }) {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (f.new_password.length < 6) { toast.error("Yeni şifre en az 6 karakter olmalı"); return; }
    if (f.new_password !== f.confirm) { toast.error("Yeni şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success(data.message); setF({ current_password: "", new_password: "", confirm: "" }); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><KeyRound className="h-5 w-5 text-primary" /> Şifre Değiştir</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-xs uppercase text-muted-foreground">Mevcut Şifre</Label>
            <Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="cp-current" /></div>
          <div className="space-y-1.5"><Label className="text-xs uppercase text-muted-foreground">Yeni Şifre</Label>
            <Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="cp-new" /></div>
          <div className="space-y-1.5"><Label className="text-xs uppercase text-muted-foreground">Yeni Şifre (Tekrar)</Label>
            <Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="cp-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>İptal</Button>
          <Button onClick={save} disabled={busy} data-testid="cp-save" className="gap-2">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Güncelle</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
